module.exports = __webpack_public_path__ + "static/23-8266345340fd70a80fe3b2b9f3151efd.jpg";